const BaseWindow = ({ show, children }: { show?: boolean, children: any }) => {
  //animate__animated ${show ? 'animate__fadeInUp' : 'hidden'} animate__fast
  return (
    <div className={`base-window-container`}>
      <div className="base-window-inner-container">{children}</div>
    </div>
  )
}
export default BaseWindow
